<template>
  <div :class="[SSectionVerticalMarginClasses]">
    <TContainer :mobile-full="true">
      <TGrid
        class="lg:rounded-lg lg:overflow-hidden"
        :class="[SSectionBackgroundColorsClasses[backgroundColor]]"
      >
        <div
          class="col-span-12 lg:col-span-6 px-4 sm:px-6"
          :class="SSectionverticalPaddingClasses"
        >
          <TTitle
            v-if="title && title.length > 0"
            :tag="titleTag"
            :size="SSectionTitleSize"
            :class="SSectionTextColorsClasses[backgroundColor]"
            :classes="SSectionTitleClasses"
            :leading="SSectionTitleLeading"
          >
            {{ title }}
          </TTitle>

          <slot />
        </div>

        <div class="col-span-12 lg:col-span-6 relative">
          <div
            class="aspect-w-5 aspect-h-3 lg:aspect-none lg:absolute lg:inset-0 lg:w-full lg:h-full"
          >
            <div class="lg:absolute lg:h-full lg:w-full overflow-hidden">
              <TLazyimg
                :sources="{
                  url: url,
                }"
                :alt="title ? title : ''"
              />
            </div>
          </div>
        </div>
      </TGrid>
    </TContainer>
  </div>
</template>

<script setup lang="ts">
import type {
  SSectionBackgroundColorsProp,
  SSectionTitleTagProp,
} from './constants'
import {
  SSectionVerticalMarginClasses,
  SSectionverticalPaddingClasses,
  SSectionBackgroundColorsClasses,
  SSectionTextColorsClasses,
  SSectionTitleTag,
  SSectionTitleSize,
  SSectionTitleClasses,
  SSectionTitleLeading,
  SSectionBackgroundColor,
} from './constants'

export interface propsInterface {
  title?: string
  titleTag?: SSectionTitleTagProp
  backgroundColor?: SSectionBackgroundColorsProp
  url: string
}

withDefaults(defineProps<propsInterface>(), {
  titleTag: SSectionTitleTag,
  backgroundColor: SSectionBackgroundColor,
})
</script>
